import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import {
    View,
    TouchableOpacity,
    ScrollView
} from 'react-native';

import {
    JDText,
    JDImage,
    JDScrollView,
    JDLogin,
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';
import st from './special-price.st';
import { pt, date_str, mta } from '../../common/utils';
import Loading from '../common/loading';
import { get } from '../../common/fetch';

const img = {
    logo: require('./img/nav.png'),
    close: require('./img/close.png'),
    right: require('./img/right.png'),
    // right: require('./img/right2.png'),
    plus: require('./img/plus.png')
};

export default class SpecialPrice extends PureComponent {
    constructor(props) {
        super(props);
        this.jumpPlace = this.jumpPlace.bind(this);
        this.jumpMovie = this.jumpMovie.bind(this);
        this.state = {
            test: this.props.test,
            isLogin: false
            // aloading: this.props.aloading
        };
    }

    render() {
        const { test } = this.state;
        const { scaleLoading } = this.props;

        return (
            <LinearGradient
                colors={ ['#FF4F18', '#FF2000'] }
                start={ { x: 0, y: 0 } }
                end={ { x: 0, y: 1 } }
                style={ { flex: 1 } }
            >
                {/* 页面顶部今日特价 */}

                <View style={ st.banner }>
                    <View style={ st.over }>
                        <View style={ st.banner_circle1 } />
                        <View style={ st.banner_circle2 } />
                        <View style={ st.banner_circle3 } />
                        <View style={ st.top }>
                            <View style={ st.left }>
                                <JDImage style={ st.logo } source={ img.logo } />
                                <JDText style={ st.text }>今日特价</JDText>
                            </View>
                            <TouchableOpacity style={ st.close_touch } onPress={ () => { this.close(); } }>
                                <JDImage style={ st.close } source={ img.close } />
                            </TouchableOpacity>
                        </View>
                    </View>
                    {/* {!aloading && <Loading contentStyle={{height: pt(450),backgroundColor: '#fff'}} />} */}
                    {<JDScrollView
                        showsVerticalScrollIndicator={ false }
                        bounces={ false }
                        alwaysBounceHorizontal={ false }
                        // style={{backgroundColor: '#000',marginBottom: pt(320)}}
                        style={ { flex: 1 } }
                    >
                        {/* 第一个大板块 */}
                        {/* <View style={st.list}> */}
                        {/* 电影详情板块 */}
                        {
                            scaleLoading
                                ? test.map((movieList, index) => {
                                    return (
                                        <View style={ st.list } key={ index }>
                                            <TouchableOpacity onPress={ () => { this.jumpMovieDetail(movieList, index); } }>
                                                <View style={ st.list_top }>
                                                    <JDImage style={ st.list_top_left } source={ { uri: movieList.jdPicUrl } } />
                                                    <View style={ st.list_top_right }>
                                                        <View style={ st.list_top_right_top }>
                                                            {/* <JDText style={st.list_top_right_top_left}>{movieList.movieName}</JDText> */}
                                                            {/* 电影的类型 */}
                                                            <View style={ { flexDirection: 'row', alignItems: 'center' } }>
                                                                <JDText numberOfLines={ 1 } style={ st.movie_name }>{movieList.movieName}</JDText>
                                                                {!!movieList.showType && movieList.showType.split('-').length == 1 &&
                                  <View style={ st.movie_type_one_wrap }>
                                      <JDText style={ st.movie_type_one }>{movieList.showType}</JDText>
                                  </View>
                                                                }
                                                                {!!movieList.showType && movieList.showType.split('-').length == 2 &&
                                  <View style={ { flexDirection: 'row', height: pt(15), alignItems: 'center' } }>
                                      <JDText style={ st.movie_type_left }>{movieList.showType.split('-')[0]}</JDText>
                                      <JDText style={ st.movie_type_right }>{movieList.showType.split('-')[1]}</JDText>
                                  </View>
                                                                }
                                                            </View>

                                                        </View>
                                                        {movieList.grade > 0
                                                            ? <JDText style={ st.list_top_right_score }>观众评分 {movieList.grade}</JDText>
                                                            : <JDText style={ st.list_top_right_score }>暂无评分</JDText>
                                                        }
                                                        <JDText numberOfLines={ 1 } style={ st.list_top_right_dir }>导演：{movieList.director || '未知'}</JDText>
                                                        <JDText numberOfLines={ 1 } style={ st.list_top_right_main }>主演：{movieList.actors || '未知'}</JDText>
                                                    </View>
                                                </View>
                                            </TouchableOpacity>

                                            <CinemaList movieList={ movieList.specialCinemaVOS } movieName={ movieList.movieName } movieId={ movieList.movieId } jumpPlace={ this.jumpPlace } jumpMovie={ this.jumpMovie } />
                                        </View>
                                    );
                                })
                                : <Loading contentStyle={ { margin: pt(10), marginTop: 0, marginBottom: 0, backgroundColor: '#fff', flex: 1, borderRadius: pt(3), paddingVertical: pt(150) } } />
                        }
                        {/* 第三个测试板块 */}
                        <View style={ { height: pt(50) + JDNativeSystem.iphoneXMarginBottom } } />
                    </JDScrollView>}
                </View>
            </LinearGradient>
        );
    }

    componentDidMount() {

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.test !== prevState.test) {
            return {
                isScrollingDown:
          nextProps.test > prevState.test,
                test: nextProps.test
            };
        }

        return null;
    }

    // 关闭弹窗函数
    close() {
        const { onHide } = this.props;

        setTimeout(() => {
            onHide();
        }, 100);
    }

  // 点击影院进入影片影院列表页
  jumpPlace = (movie, movieId, index) => {
      // cinemaID_是否常去影院_影院排序（列表的排序从1开始）
      console.log(movie, index);
      mta('SpecPopCinema', 'Home', `${movieId}_0_${index + 1}`);
      this.context.router.toMovieList({ movieId, cinemaId: movie.cinemaId, skuId: movie?.skuId });
  }

  // 点击场次进入选座页
  jumpMovie = (planList, movieName, cinemaName, cinemaId, index) => {

      const seat = {
          planId: planList.planId, // 场次id
          title: cinemaName, // 影院名称
          movieName, // 影片名称
          theDate: date_str(new Date(), false), // 选择日期 [2018-8-27]
          startTime: planList.startTime, // 影片开始时间 [13:00]
          playType: planList.playType, // 影片信息（3d/2d)
          hallName: planList.hallName, // 影厅信息（几号厅）
          promtId: planList.promtId
      };
      console.log(planList);
      // cinemaID_场次时间（格式2018-11-12 15:30:00）_价格_影院顺序（列表的排序从1开始）
      mta('SpecPopField', 'Home', `${cinemaId}_${seat.theDate} ${seat.startTime}_${planList.jdPrice / 100}_${index + 1}`);

      const that = this;
      JDLogin.isLogin().then(() => {
          jump(that);
      }, () => {
          JDLogin.doLogin().then(() => {
              jump(that);
          });
      }).catch(() => jump());

      function jump(that) {
          that.setState({
              isLogin: true
          });

          that.context.router.toSeat(seat);
      }
  }

  // 点击跳转到影片详情页
  jumpMovieDetail(movieList, index) {
      this.context.router.toMovieDetail({ movieId: movieList.movieId });

      // 电影票sku_movieID_影片权重_影院顺序（列表的排序从1开始）
      mta('SpecPopMov', 'Home', `${movieList.jSkuId}_${movieList.movieId}_${movieList.weight}_${index + 1}`);
  }
}

class CinemaList extends PureComponent {
    render() {
        const { movieList, jumpPlace, jumpMovie, movieName, movieId } = this.props;

        return (
            <View>
                {
                    movieList.map((val, index) => {
                        return (
                            <View key={ index }>
                                <TouchableOpacity onPress={ () => jumpPlace(val, movieId, index) }>
                                    <View style={ st.place }>
                                        <View style={ st.place_left }>
                                            <JDText numberOfLines={ 1 } style={ st.place_left_left }>{val.cinemaName}</JDText>
                                            <JDImage style={ st.place_left_right } source={ img.right } />
                                        </View>
                                        <JDText style={ st.place_right }>{val.cinemaDistanceStr}</JDText>
                                    </View>
                                </TouchableOpacity>
                                <ScrollView
                                    showsHorizontalScrollIndicator={ false }// 水平滚动条
                                    showsVerticalScrollIndicator={ false }// 垂直滚动条
                                    horizontal={ true }
                                    style={ { height: pt(77) } }
                                >
                                    {
                                        val.specialPlanVOS.map((planList, index) => {
                                            let priceRise = planList?.isPartitionPrice ? <JDText style = {st.priceRise}>起</JDText>: "";
                                            return (
                                                <View style={ st.content } key={ index }>
                                                    <TouchableOpacity onPress={ () => { jumpMovie(planList, movieName, val.cinemaName, val.cinemaId, index); } }>
                                                        <View style={ st.content_content }>
                                                            <JDText style={ st.content_content_left }>{planList.startTime}</JDText>
                                                            <JDText style={ st.content_content_mid }>{planList.playType}</JDText>
                                                            <View style={ st.content_content_right }>
                                                                {planList.promoType == -1
                                                                    ? <JDText style={ st.content_content_right_left }>¥{(planList.jdPrice) / 100}
                                                                        {priceRise}
                                                                </JDText>
                                                                    : <JDText style={ st.content_content_right_left }>¥{(planList.promoPrice || 0) / 100}
                                                                        {priceRise}
                                                                    </JDText>
                                                                }
                                                                {
                                                                    planList.promoType > -1 && planList.promoPrice && planList.promoPrice.length < 7 && <View style={ st.content_hui }>
                                                                        <JDText style={ st.content_content_right_right }>惠</JDText>
                                                                    </View>
                                                                }
                                                            </View>
                                                        </View>
                                                    </TouchableOpacity>
                                                </View>
                                            );
                                        })
                                    }
                                </ScrollView>
                            </View>
                        );
                    })
                }
            </View>
        );
    }
}

SpecialPrice.contextTypes = {
    router: PropTypes.object
};
